import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import NumberFormat from 'react-number-format';
import Script from 'react-load-script'
import { formatDate, parseDate } from 'react-day-picker/moment';
import "react-datepicker/dist/react-datepicker.css";
import './Transactions.scss';
import { ToastContainer, toast } from 'react-toastify';
import {Redirect, Link} from 'react-router-dom';
import Icon from 'react-icons-kit';
import {ic_keyboard_arrow_down} from 'react-icons-kit/md/ic_keyboard_arrow_down'
import InfiniteScroll from "react-infinite-scroll-component";

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

class TransactionsCarbon extends Component {
   constructor(props) {
      super(props);
      this.state = {
         loggedIn: false,
         loading:true,
         orders: [],
         order_status : [],
         order_pagination: {
            page: 1, // Default Page
            limit: 10 // Default Limit
         },
         activeDropdown: '',
         hasMore: true,
         pagination: [],
         stickyTableHead: false,
         from: undefined,
         to : undefined,
         reserve : undefined,
         filterStatus : 'Status',
         dropdownFilterStatus : false,
         prevScrollPos: window.pageYOffset,
         hitGetActions : 0,
         scriptLoaded : null,
         scriptError : null,
         loaderButton : [],
      };
      this.setWrapperRef = this.setWrapperRef.bind(this);
      this.handleChangeSelect = this.handleChangeSelect.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.handleFromChange = this.handleFromChange.bind(this);
      this.handleToChange = this.handleToChange.bind(this);
   }

   handleScriptCreate() {
      this.setState({ scriptLoaded: false })
   }
   handleScriptError() {
      this.setState({ scriptError: true })
   }  
   handleScriptLoad() {
      this.setState({ scriptLoaded: true })
   }

   handleChangeSelect(event) {
      console.log('event target value ', event);
      this.setState({status: this.state.status, orders:[], loading:true, hasMore : true, order_pagination : {page: 1}}, () => {
            this.get_order_list()
      });
   }

   showFromMonth() {
      const { from, to } = this.state;
      if (!from) {
         return;
      }
      if (moment(to).diff(moment(from), 'months') < 2) {
            this.to.getDayPicker().showMonth(from);
      }
      this.setState({orders:[], loading:true, hasMore : true, order_pagination : {page: 1}}
         , () => {
            this.get_order_list()
      });
   }

   handleFromChange(from) {
      console.log('from handle change ', from)
      // Change the from date and focus the "to" input field
      this.setState({ from });
   }

   handleToChange(to) {
      console.log('to handle change ', to)
      this.setState({ to }, this.showFromMonth);
   }
   
   setWrapperRef(node) {
      this.wrapperRef = node;
   }

   handleClickOutside(event) {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
         console.log('You clicked outside of me! ');
         this.setState({activeDropdown : ''})
      }
   }
   handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      if(currentScrollPos > 100){
         this.setState({
            stickyTableHead: true,
         }); 
      } else {
         this.setState({
            stickyTableHead: false,
         }); 
      } 
   };
   handleDropdownClick = (e) => {
      console.log('handleDropdownClick ', e);
      this.setState({
         activeDropdown: e
      });
   };

   get_order_list = () => {
      if(this.state.from === undefined){
         if(this.state.status === undefined){
            var url = process.env.REACT_APP_API_HOST + '/order/carbon/list?startDate='+ moment().subtract(7,'d').format('DD-MM-YYYY') + '&endDate='+ moment(new Date()).format('DD-MM-YYYY') +'&page=' + this.state.order_pagination.page + '&limit=10&status=';
         } else {
            var url = process.env.REACT_APP_API_HOST + '/order/carbon/list?startDate='+ moment().subtract(7,'d').format('DD-MM-YYYY') +'&endDate='+ moment(new Date()).format('DD-MM-YYYY') +'&page=' + this.state.order_pagination.page + '&limit=10&status='+ this.state.status;
         }
      } else {
         if(this.state.status === undefined){
            var url = process.env.REACT_APP_API_HOST + '/order/carbon/list?startDate=' + moment(this.state.from).format("DD-MM-YYYY") + '&endDate=' + moment(this.state.to).format("DD-MM-YYYY") + '&page=' + this.state.order_pagination.page + '&limit=10&status=';
         } else {
            var url = process.env.REACT_APP_API_HOST + '/order/carbon/list?startDate=' + moment(this.state.from).format("DD-MM-YYYY") + '&endDate=' + moment(this.state.to).format("DD-MM-YYYY") + '&page=' + this.state.order_pagination.page + '&limit=10&status='+this.state.status;
         }
         
      }
      var configHeader = {
         headers: {
            'Content-Type' : 'application/json',
            'token': JSON.parse(localStorage.getItem("userData")).token
         },
      }
      axios.get(url, configHeader)
      .then(res => {
         console.log('res transaction carbon list ', res.data)
         if (res.data.status === true) {
            setTimeout(() => {
               console.log('res data transaction ', res.data)
               if(res.data.pagination.total !== 0){
                  var ordersNew = this.state.orders;
                  res.data.data.map((order) => {
                     ordersNew.push(order);
                  });
                  if(this.state.order_pagination.page < res.data.pagination.pageCount + 1) {
                     this.setState({
                        orders: ordersNew,
                        hasMore : true,
                        order_pagination : {page: res.data.pagination.page + 1},
                        loading:false
                     });
                  } else {
                     this.setState({
                        orders: ordersNew,
                        hasMore : false,
                        loading:false
                     });
                  }
               } else {
                  this.setState({
                     orders:null,
                     hasMore : false,
                     loading:false
                  });
               }
            }, 1000)
         } else {
            this.setState({ status: false, error: res.data.error, loading: false })
         }
      })
   }

   
   payCarbon = debounce( (paymentType, idorder, id) => {
      let loading = this.state.loaderButton.slice();
      loading[id] = true;
      this.setState({
         loaderButton: loading
     });

      console.log('paymentType ', paymentType)
      console.log('idorder ', idorder)
      console.log('id index  ', id )

      if(paymentType === 0){
         setTimeout(
            function(){
               window.location.href = '/payment/carbon/status/'+ idorder
            }, 1000
         )
      } else {
         this.getActionsByIdOrder(idorder)
      }
   }, 100);

   
   getActionsByIdOrder = debounce( (idorder) => {
      axios({
         method: 'GET',
         url: '/order/actions/'+idorder,
         headers: {
            "Content-Type": 'application/json',
            "token": JSON.parse(localStorage.getItem("userData")).token
         }
      }).then(
         (res) => {
            console.log('res.data actions ', res.data);
            if(res.data.status){
               if(res.data.data.token){
                  setTimeout(
                     function(){
                        window.snap.pay(res.data.data.token, {
                           // Optional
                           onSuccess: function(result){
                              /* You may add your own js here, this is just example */ 
                              console.log('customer onSuccess ', result);
                              if(result.status_code === '200'){
                                 setTimeout(
                                    function(){
                                       window.location.href = '/payment/carbon/status/'+ res.data.data.orderId
                                    }, 1000
                                 )
                              }
                           },
                           // Optional
                           onPending: function(result){
                              /* You may add your own js here, this is just example */
                              console.log('customer onPending ', result);
                              setTimeout(
                                 function(){
                                    window.location.href = '/payment/carbon/status/'+ res.data.data.orderId
                                 }, 1000
                              )
                           },
                           // Optional
                           onError: function(result){
                              /* You may add your own js here, this is just example */ 
                              console.log('customer onError ', result);
                              if(result.status_message.length){
                                 for(var er = 0; er < result.status_message.length; er++){
                                    var obj = result.status_message[er];
                                    toast.warning(obj);
                                 }
                              } else {
                                 toast.error( result.status_message );
                              }
                              setTimeout(
                                 function(){
                                    window.location.href = '/transaction/carbon'
                                 }, 2000
                              )
                           },
                           onClose: function(result){
                              console.log('customer closed the popup without finishing the payment', result);
                              setTimeout(
                                 function(){
                                    window.location.href = '/payment/carbon/status/'+ res.data.data.orderId
                                 }, 1000
                              )
                           }
                        });
                     }
                  , 2500)
               }
            } else {
               if(this.state.hitGetActions < 60){
                  // call again
                  console.log('call again getactions ')
                  this.setState({hitGetActions : this.state.hitGetActions + 1}, () => this.getActionsByIdOrder(idorder) )
               } else {
                  // error
                  setTimeout(() => {
                     this.setState({loaderButton: false, errorState:true, error:'Sorry, something went wrong.'})
                  }, 1000)
               }
            }
         },
         (error) => {
            
         }
      );
   }, 1500);
   
   componentDidMount() {
      const userData = localStorage.getItem("userData");
      if(userData){
         this.setState({loggedIn : true, companyName : JSON.parse(userData).data.companyName}) 
      }
      this.get_order_list();
      document.addEventListener('mousedown', this.handleClickOutside)
      window.addEventListener("scroll", this.handleScroll);
   }

   componentWillUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
   }
   
   render() {
      if(!localStorage.getItem('userData')){
         return (<Redirect to={'/'}/>)
      } 
      const { from, to } = this.state;
      const modifiers = { start: from, end: to };
      return (
         <React.Fragment>
            <div className="nav nav-main-bottom shadow-bottom">
               <div className="container">
                  <div className="row align-items-center">
                     <div className="col">
                        <ul className="nav-tab">
                           <li>
                              <Link data-menu="tree" to="/transaction/tree">
                              Tree
                              </Link>
                           </li>
                           <li className="active">
                              <Link data-menu="carbon" to="#">
                              Carbon
                              </Link>
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
            <div className="mpl-page login">
            <Script
               url="https://app.sandbox.midtrans.com/snap/snap.js"
               attributes={{ 'data-client-key': 'SB-Mid-client-6xtIpPTnXjeq_UiJ'}}
               onCreate={this.handleScriptCreate.bind(this)}
               onError={this.handleScriptError.bind(this)}
               onLoad={this.handleScriptLoad.bind(this)}
               />
               <ToastContainer autoClose={1500}/>
            {
               this.state.loading === true ? (<div className="text-center" style={{marginTop:'40px',}}><div className="loader" style={{height:'24px', width:'24px', borderColor:'#00880d', borderTopColor:'#ddd', margin:'auto'}}></div></div>) : (
                  <React.Fragment>
                     <div style={{overflowX:'auto'}}>
                        <div style={{minWidth:'1140px', minHeight:'300px', paddingBottom:'20px'}}>
                           <div className={this.state.stickyTableHead ? 'tb-header tb-sticky' : 'tb-header'}>
                              <div className="container">
                                 <div className="row">
                                    <div className="col-sm-12">
                                       <div className="tbr-flex">
                                          <div className="tbc-flex tbc-3-1">
                                             <div className="span tbc-date">
                                                Tanggal
                                                <Icon size={20} icon={ic_keyboard_arrow_down} />
                                                </div>
                                                <div className="InputFromTo">
                                                   <DayPickerInput
                                                      value={from}
                                                      placeholder={'Start date'}
                                                      format="LL"
                                                      formatDate={formatDate}
                                                      parseDate={parseDate}
                                                      dayPickerProps={{
                                                         selectedDays: [from, { from, to }],
                                                         disabledDays: { after: to },
                                                         toMonth: to,
                                                         modifiers,
                                                         numberOfMonths: 1,
                                                         onDayClick: () => this.to.getInput().focus(),
                                                      }}
                                                      onDayChange={this.handleFromChange}
                                                   />
                                                   <span className="InputFromTo-to">
                                                      <DayPickerInput
                                                         ref={el => (this.to = el)}
                                                         value={to}
                                                         placeholder={'End date'}
                                                         format="LL"
                                                         formatDate={formatDate}
                                                         parseDate={parseDate}
                                                         dayPickerProps={{
                                                         selectedDays: [from, { from, to }],
                                                         disabledDays: { before: from },
                                                         modifiers,
                                                         month: from,
                                                         fromMonth: from,
                                                         numberOfMonths: 1,
                                                         }}
                                                         onDayChange={this.handleToChange}
                                                      />
                                                   </span>
                                                </div>
                                                <small style={{fontSize:'11px', position:'absolute', top:'-3px', fontWeight:'normal', color:'#777'}}>
                                                   {from && !to && 'Please select end date.'}
                                                   {from &&
                                                      to &&
                                                      `${from.toLocaleDateString()} -
                                                         ${to.toLocaleDateString()}`}{' '}
                                                </small>
                                          </div>
                                          <div className="tbc-flex">Invoice</div>
                                          <div className="tbc-flex">
                                          Total VCU
                                          </div>
                                          <div className="tbc-flex">Grand Total</div>
                                          <div className="tbc-flex tbc-3-1">
                                             <span className="tbc-filter" onClick={ () => {this.setState({dropdownFilterStatus: !this.state.dropdownFilterStatus})} }>
                                                {this.state.filterStatus} &nbsp;<Icon size={20} icon={ic_keyboard_arrow_down} />
                                                </span>
                                                <div className={this.state.dropdownFilterStatus ? 'dropdown-menu show' : 'dropdown-menu'} style={{zIndex:'20'}}>
                                                   <Link to="#" className="dropdown-item" onClick={ () => {this.setState({filterStatus: 'Status', status:undefined, dropdownFilterStatus:false}, ()=> {this.handleChangeSelect()} )}  }>Semua</Link>
                                                   <Link to="#" className="dropdown-item" onClick={ () => {this.setState({filterStatus: 'LUNAS', status:1, dropdownFilterStatus:false},  ()=> {this.handleChangeSelect()} )} }>LUNAS</Link>

                                                   <Link to="#" className="dropdown-item" onClick={ () => {this.setState({filterStatus: 'TERTUNDA', status: 0, dropdownFilterStatus:false}, ()=> {this.handleChangeSelect()} )} }>TERTUNDA</Link>
                                                   <Link to="#" className="dropdown-item" onClick={ () => {this.setState({filterStatus: 'GAGAL', status: 2, dropdownFilterStatus:false}, ()=> {this.handleChangeSelect()} )} }>GAGAL</Link>
                                                   <Link to="#" className="dropdown-item" onClick={ () => {this.setState({filterStatus: 'KADALUWARSA', status: 3, dropdownFilterStatus:false}, ()=> {this.handleChangeSelect()} )} }>KADALUWARSA</Link>
                                                </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div className="container">
                              <div className="row">
                                 <div className="col-sm-12">
                                    <div className="tb-body" ref={this.setWrapperRef}>
                                    {this.state.orders ? (
                                       <InfiniteScroll
                                       dataLength={this.state.orders.length}
                                       next={this.get_order_list}
                                       hasMore={this.state.hasMore}
                                       loader={<div className="text-center" style={{marginTop:'40px',}}><div className="loader" style={{height:'24px', width:'24px', borderColor:'#00880d', borderTopColor:'#ddd', margin:'auto'}}></div></div>}> 
                                    {
                                       this.state.orders.map((order) => {
                                          return(
                                             <div className="tbr-flex" key={order.orderId}>
                                                <div className="tbc-flex tbc-3-1">
                                                {moment(order.createdAt).format("ll")}
                                                </div>
                                                <div className="tbc-flex">
                                                {order.invoiceId}
                                                </div>
                                                <div className="tbc-flex">
                                                {order.totalVcu}
                                                </div>
                                                <div className="tbc-flex">
                                                   <span className="text-orange text-bold">
                                                   {order.orderDetails[0].currencySymbol}
                                                &nbsp;<NumberFormat value={order.grandTotal} displayType={'text'} thousandSeparator={','} decimalSeparator={'.'} decimalScale={0}/>
                                                   </span>
                                                </div>
                                                <div className="tbc-flex tbc-3-1">
                                                {order.statusMessage === 'UNPAID' ? (
                                                <React.Fragment>
                                                   {
                                                      this.state.loaderButton[order.orderId] ? (
                                                         <button className="btn btn-pay-small btn-orange text-center" style={{opacity:'.7'}}><div className="loader" style={{width:'22px', height:'22px', marginTop:'2px'}}></div></button>
                                                      ) : (
                                                         <button className="btn btn-pay-small btn-orange text-center" onClick={ () => this.payCarbon(order.paymentType, order.orderId, order.orderId) }>
                                                            Bayar
                                                         </button>
                                                      )
                                                   }
                                                </React.Fragment>
                                                ) : order.statusMessage === 'PAID' ?(
                                                   <button className="btn btn-pay-small btn-disabled text-center">
                                                      <span className="text-green">LUNAS</span>
                                                   </button>
                                                ) : (
                                                   <React.Fragment>
                                                      {order.statusMessage === 'FAILED' ? (
                                                         <button className="btn btn-pay-small btn-disabled text-center">
                                                            <span className="text-red">
                                                               GAGAL
                                                            </span>
                                                         </button>
                                                      ) : (
                                                         <button className="btn btn-pay-small btn-disabled text-center">
                                                            <span className="text-red">
                                                               KADALUWARSA
                                                            </span>
                                                         </button>
                                                      )}
                                                   </React.Fragment>
                                                )}
                                                </div>
                                             </div>
                                          )
                                       })
                                    }
                                    </InfiniteScroll>
                                    ) : (
                                       <div className="text-center mt-3">
                                          <small>Tidak ada data transaksi</small>
                                       </div>
                                    )}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </React.Fragment>
               )
            }
            </div>
         </React.Fragment>
         )
      }
   }

   export default TransactionsCarbon;